module.exports = {
          srcSet: "/_next/static/images/google-meet-48-3213cbe2de5d130c3110d51c43d93549.webp"+" 48w",
          images:[ {path: "/_next/static/images/google-meet-48-3213cbe2de5d130c3110d51c43d93549.webp",width: 48,height: 48}],
          src: "/_next/static/images/google-meet-48-3213cbe2de5d130c3110d51c43d93549.webp",
          toString:function(){return "/_next/static/images/google-meet-48-3213cbe2de5d130c3110d51c43d93549.webp"},
          
          width: 48,
          height: 48
        }